import React, { useEffect, useState } from "react";
import { Phone, WhatsappLogo, X } from "@phosphor-icons/react";
import { CONTACT } from "../lib/api";
import { useLocation } from "react-router-dom";

export default function FloatingContact() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  useEffect(() => { setOpen(false); }, [location.pathname]);

  if (isAdmin) return null;

  return (
    <div className="fixed bottom-6 right-6 z-[10000] flex flex-col items-end gap-3" data-testid="floating-contact">
      <div
        className={`flex flex-col items-end gap-3 transition-all duration-200 ${
          open ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-2 pointer-events-none"
        }`}
      >
        <a
          href={`https://wa.me/91${CONTACT.whatsapp}?text=Hi%20Orax%20Solar,%20I%20want%20a%20free%20solar%20quote`}
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-2 pl-4 pr-3 py-3 rounded-full bg-[#25D366] text-white shadow-lg hover:-translate-y-0.5 transition"
          data-testid="floating-whatsapp"
        >
          <span className="text-sm font-semibold">Chat on WhatsApp</span>
          <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
            <WhatsappLogo weight="fill" size={20} />
          </div>
        </a>
        <a
          href={`tel:${CONTACT.phonePrimary}`}
          className="flex items-center gap-2 pl-4 pr-3 py-3 rounded-full bg-[#0F52BA] text-white shadow-lg hover:-translate-y-0.5 transition"
          data-testid="floating-call"
        >
          <span className="text-sm font-semibold">Call Now</span>
          <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
            <Phone weight="fill" size={20} />
          </div>
        </a>
      </div>

      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-14 h-14 rounded-full bg-[#135934] text-white shadow-xl hover:-translate-y-0.5 transition flex items-center justify-center relative"
        aria-label="Contact"
        data-testid="floating-toggle"
      >
        {open ? <X weight="bold" size={24} /> : <Phone weight="fill" size={24} />}
        {!open && (
          <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-[#FDB813] pulse-dot pointer-events-none"></span>
        )}
      </button>
    </div>
  );
}
